'use strict';

module.exports = Object.assign({}, require('./errors'), require('./error-marks'));